import {
  THIET_LAP_KHAC_API,
} from "constants/ApiConstant";
import axiosInstance from "auth/FetchInterceptor";
const ThietLapKhacCategoryService = {};

ThietLapKhacCategoryService.get = function () {
  return axiosInstance.get(`${THIET_LAP_KHAC_API}/NganHang/search`);
};
ThietLapKhacCategoryService.upSert = function (data) {
  return axiosInstance.post(`${THIET_LAP_KHAC_API}/NganHang/up-sert`, data);
};

export default ThietLapKhacCategoryService;
